import React from 'react';
import { useSearchParams } from 'react-router-dom';
import { FileText, BookOpen, Palette } from 'lucide-react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../components/ui/tabs';
import Layout from '../components/Layout';

// Import des composants existants
import Templates from './Templates';
import TemplateLibrary from './TemplateLibrary';

export default function TemplatesHub() {
  const [searchParams, setSearchParams] = useSearchParams();
  const defaultTab = searchParams.get('tab') || 'templates';

  const handleTabChange = (value) => {
    setSearchParams({ tab: value });
  };

  return (
    <Layout>
      <div className="space-y-6" data-testid="templates-hub-page">
        {/* Header */}
        <div className="flex items-center justify-between">
          <div>
            <h1 className="text-2xl font-bold text-slate-900 flex items-center gap-2">
              <FileText className="h-7 w-7 text-indigo-600" />
              Templates RCS
            </h1>
            <p className="text-slate-500 mt-1">
              Créez et gérez vos modèles de messages RCS
            </p>
          </div>
        </div>

        {/* Tabs */}
        <Tabs value={defaultTab} onValueChange={handleTabChange} className="w-full">
          <TabsList className="grid w-full max-w-md grid-cols-2 mb-6">
            <TabsTrigger value="templates" className="flex items-center gap-2" data-testid="tab-templates">
              <Palette className="h-4 w-4" />
              Mes Templates
            </TabsTrigger>
            <TabsTrigger value="library" className="flex items-center gap-2" data-testid="tab-library">
              <BookOpen className="h-4 w-4" />
              Bibliothèque
            </TabsTrigger>
          </TabsList>

          <TabsContent value="templates" className="mt-0">
            <Templates embedded={true} />
          </TabsContent>

          <TabsContent value="library" className="mt-0">
            <TemplateLibrary embedded={true} />
          </TabsContent>
        </Tabs>
      </div>
    </Layout>
  );
}
